import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import useUsers from '@/hooks/use-users';
import type { FinanceManager } from '@/models/types';
import { COMBO_BOX_OPTIONS } from '../combobox-popovers/all-filters-combobox-popover';
import FinanceManagerFiltersComboBoxPopover from '../combobox-popovers/finance-manager-filters-combobox-popover';
import {
  type FinanceManagerFilterChipProps,
  type FinanceManagerFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const FinanceManagerFilterChipSelectedFilterBadge = ({
  value,
}: {
  value: FinanceManager['id'];
}) => {
  // DEV NOTE: for the `my deals filters` we set the `users` to be the `finance managers`
  // even if the user isn't a finance manager
  // thus we need to show avatar for all users
  const { users: financeManagers } = useUsers();

  const financeManager = financeManagers.find((fm) => fm.id === value);

  if (!financeManager) {
    return null;
  }

  return (
    <PaddockAvatar
      src={financeManager?.avatar}
      alt={financeManager?.first_name}
      fallback={financeManager?.first_name}
      className="size-4"
    />
  );
};

const FinanceManagerFilterChip = (props: FinanceManagerFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<FinanceManager['id'], FinanceManagerFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={FinanceManagerFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS.find((option) => option.value === 'finance_manager')
          ?.icon
      }
      filterName="Finance Manager"
      filterQuantifier={{
        singular: 'finance manager',
        plural: 'finance managers',
      }}
      SelectedFilterBadge={FinanceManagerFilterChipSelectedFilterBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default FinanceManagerFilterChip;
